import PropTypes from "prop-types";
import styles from "./index.css";
import ProductColourSelect from "../ProductColourSelect";
import ToBagButton from "../ToBagButton";
import filterSelectedColourVariants from "./filterSelectedColourVariants";
import SeeSimilarButton from "../SeeSimilarButton";
import shouldShowToBagButton from "./shouldShowToBagButton";
import { ACCESS_LEVEL_VIEW } from "../../../../constants";

const SavedItemsProductTileControls = ({
  colourWayId,
  isNoSize,
  isOneColour,
  isOneSize,
  isProductInStock,
  isVariantInStock,
  isForceDisabled,
  variantId,
  variants,
  itemToBag,
  updateItemColour,
  updateItemVariant,
  toBagButtonText,
  productId,
  ProductSizeSelectComponent,
  customerAccess,
  ...rest
}) => {
  const variantsBySelectedColour = filterSelectedColourVariants(
    variants,
    colourWayId
  );

  const areDropdownsDisabled =
    isForceDisabled || customerAccess === ACCESS_LEVEL_VIEW;

  return (
    <>
      <ProductColourSelect
        colourWayId={colourWayId}
        variants={variants}
        isOneColour={isOneColour}
        isForceDisabled={areDropdownsDisabled}
        onChange={updateItemColour}
      />
      <ProductSizeSelectComponent
        variantId={variantId}
        variants={variantsBySelectedColour}
        isOneSize={isOneSize}
        isNoSize={isNoSize}
        isForceDisabled={areDropdownsDisabled}
        onChange={updateItemVariant}
        {...rest}
      />
      {shouldShowToBagButton({
        isProductInStock,
        isVariantInStock,
        customerAccess
      }) ? (
        <ToBagButton
          className={styles.toBagButton}
          onClick={itemToBag}
          buttonText={toBagButtonText}
          isDisabled={isForceDisabled || variantId === null}
        />
      ) : (
        <SeeSimilarButton productId={productId} isDisabled={isForceDisabled} />
      )}
    </>
  );
};

SavedItemsProductTileControls.propTypes = {
  colourWayId: PropTypes.number.isRequired,
  isNoSize: PropTypes.bool.isRequired,
  isOneColour: PropTypes.bool.isRequired,
  isOneSize: PropTypes.bool.isRequired,
  isProductInStock: PropTypes.bool.isRequired,
  isVariantInStock: PropTypes.bool,
  isForceDisabled: PropTypes.bool,
  variantId: PropTypes.number,
  variants: PropTypes.array.isRequired,
  itemToBag: PropTypes.func.isRequired,
  updateItemColour: PropTypes.func.isRequired,
  updateItemVariant: PropTypes.func.isRequired,
  toBagButtonText: PropTypes.string.isRequired,
  productId: PropTypes.number.isRequired,
  ProductSizeSelectComponent: PropTypes.elementType.isRequired,
  customerAccess: PropTypes.string
};

export default SavedItemsProductTileControls;
